(($) => {
  function applyFlextable() {
    const tables = $('.node__content table');
    tables.each(function applyTheFlextable() {
      jQuery(this).flextable({
        debug: true,
        bt: 'window',
        bw: 991,
        cm: 'load',
        // hparent: '',
        // hcell: '',
        // header: 'before',
        combine: true,
      });
    });
  }

  // Listen for DOM Ready events.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      applyFlextable();
    },
    false,
  );
})(jQuery);
